export const getGreeceData = () => ({
  name: "Grèce",
  description: "La Grèce est l'un des plus anciens pays viticoles du monde, avec une tradition millénaire remontant à l'Antiquité, produisant des vins uniques à partir de cépages autochtones.",
  type: "country",
  regions: [
    { name: "Crète", area: "35,000 ha", percentage: "20%", description: "Plus grande île viticole" },
    { name: "Péloponnèse", area: "25,000 ha", percentage: "14%", description: "Région historique" },
    { name: "Macédoine", area: "22,000 ha", percentage: "13%", description: "Vins rouges du nord" },
    { name: "Épire", area: "18,000 ha", percentage: "10%", description: "Vins de montagne" },
    { name: "Thessalie", area: "15,000 ha", percentage: "9%", description: "Plaines centrales" },
    { name: "Attique", area: "12,000 ha", percentage: "7%", description: "Région d'Athènes" },
    { name: "Îles Égéennes", area: "20,000 ha", percentage: "11%", description: "Vins insulaires" },
    { name: "Îles Ioniennes", area: "8,000 ha", percentage: "5%", description: "Vins de l'ouest" },
    { name: "Autres", area: "20,000 ha", percentage: "11%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Crète", x: 25.0, y: 35.2, color: "#4B164C", size: 8 },
    { region: "Péloponnèse", x: 22.5, y: 37.5, color: "#6d2c7a", size: 7 },
    { region: "Macédoine", x: 22.5, y: 40.5, color: "#8a4a8a", size: 6 },
    { region: "Épire", x: 20.5, y: 39.5, color: "#a768a6", size: 5 },
    { region: "Thessalie", x: 22.5, y: 39.5, color: "#c486c4", size: 5 },
    { region: "Attique", x: 23.5, y: 38.0, color: "#e2a4e2", size: 4 },
    { region: "Îles Égéennes", x: 25.5, y: 37.0, color: "#f0c2f0", size: 6 },
    { region: "Îles Ioniennes", x: 20.5, y: 38.5, color: "#f8e0f8", size: 3 }
  ],
  statistics: {
    totalArea: "175,000 ha",
    production: "2.5 million hectolitres",
    regions: "9 régions principales",
    appellations: "28 appellations d'origine",
    exportPercentage: "15%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influences continentales au nord, étés chauds et secs",
    soil: "Variété géologique : calcaires, argiles, schistes, granit, sols volcaniques",
    viticulture: "Tradition ancienne, cépages autochtones, techniques modernes"
  },
  wineStyles: {
    red: "Vins rouges structurés et aromatiques, avec des notes d'épices et d'herbes méditerranéennes",
    white: "Vins blancs secs et aromatiques, avec une fraîcheur et une complexité uniques",
    rosé: "Rosés fruités et équilibrés, parfaits pour l'apéritif",
    sweet: "Vins doux naturels traditionnels, comme le Muscat de Samos"
  },
  history: "La viticulture grecque remonte à plus de 4000 ans. Les Grecs anciens ont développé les premières techniques viticoles et ont exporté le vin dans tout le bassin méditerranéen. Dionysos, dieu du vin, était l'une des divinités les plus importantes. Aujourd'hui, la Grèce combine cette tradition millénaire avec des techniques modernes.",
  foodPairing: "Cuisine grecque traditionnelle, mezzés, fromages feta et halloumi, poissons méditerranéens"
}); 